export const REPORT_TIME_INTERVAL = 10000
export const MAX_EVENTLIST_LENGTH = 20
export const eventListKey = 'TRACER_EVENTLIST'
export const pageHistoryKey = 'TRACER_PAGEHISTORY'
export const bridgeListKey = 'TRACER_BRIDGELIST'
